import React from 'react';
import { Box, CircularProgress, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '200px',
    padding: theme.spacing(3),
  },
  fullScreenLoader: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingText: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    textAlign: 'center',
  },
  spinner: {
    color: theme.palette.primary.main,
  },
}));

interface LoadingSpinnerProps {
  message?: string;
  size?: number;
  fullScreen?: boolean;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 40,
  fullScreen = false,
  className,
}) => {
  const classes = useStyles();

  const containerClass = fullScreen ? classes.fullScreenLoader : classes.loadingContainer;

  return (
    <Box className={`${containerClass} ${className || ''}`}>
      <CircularProgress size={size} className={classes.spinner} thickness={4} />
      {message && (
        <Typography variant="body2" className={classes.loadingText}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
